import React, {useEffect, useState} from 'react';
import {Languages} from "../../utilities/Constants";
import Category from "../../classes/Category";
import Podcast from "../../classes/Podcast";
import Post from "../../classes/Post";
import PageTitle from "../../components/common/page-title/PageTitle";
import {Link} from "react-router-dom";
import PrimaryButton from "../../components/common/buttons/PrimaryButton";
import {FiPlus} from "react-icons/fi";
import FilterHeader from "../../components/common/header/FilterHeader";
import {Col, Container, Row} from "react-grid-system";
import SelectInput from "../../components/common/inputs/select-input/SelectInput";
import PodcastsTable from "../../components/tables/PodcastsTable";
import PaginationTableFooter from "../../components/common/footer/PaginationTableFooter";
import PostsTable from "../../components/tables/PostsTable";

const Posts = () => {

    const allCategory = {key: "-1", value: "All"};

    let limit = 15;

    const [posts, setPosts] = useState([]);
    const [postsCategories, setPostsCategories] = useState([allCategory]);
    const [loading, setLoading] = useState(true);

    const [selectedLanguage, setSelectedLanguage] = useState(Languages[0]);
    const [selectedCategory, setSelectedCategory] = useState(postsCategories[0]);

    const [currentPage, setCurrentPage] = useState(1);
    const [numberOfPages, setNumberOfPages] = useState(1);
    const [count, setCount] = useState(0);
    const [skip, setSkip] = useState(0);

    useEffect(() => {

        let isMounted = true;
        const controller = new AbortController();

        const fetchCategories = async () => {
            try {
                const results = await Category.getPickableQuery().find();
                if (isMounted) {
                    const mappedResults = [allCategory];
                    mappedResults.push(...results.map(function(item) { return {
                        key: item.id,
                        value: item.getTitle()
                    }}));
                    setPostsCategories(mappedResults);
                }
            }
            catch (error) {
                console.error(error);
            }
        }

        fetchCategories();

        return () => {
            isMounted = false;
            controller.abort();
        }

    }, []);

    useEffect(() => {

        let isMounted = true;
        const controller = new AbortController();

        const fetchPosts = async () => {
            try {
                setLoading(true);
                const response = await Post.getFilteredQuery(
                    selectedLanguage.key,
                    selectedCategory.key === "-1" ? null : selectedCategory.key,
                    skip,
                    limit
                ).find();
                if (isMounted) {
                    setCount(response.count)
                    setNumberOfPages(Math.ceil(response.count / limit))
                    if (response.count === 0) {
                        setCurrentPage(0)
                    }
                    else {
                        setCurrentPage((skip + limit) / limit)
                    }
                    setPosts(response.results);
                }
            }
            catch (error) {
                console.error(error);
            }
            finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        }

        fetchPosts();

        return () => {
            isMounted = false;
            controller.abort();
        }

    }, [selectedLanguage, selectedCategory, skip]);

    const languageSelectChangeHandler = (e) => {
        setSelectedLanguage(e);
        setSkip(0);
    }

    const postCategorySelectChangeHandler = (e) => {
        setSelectedCategory(e);
        setSkip(0);
    }

    return (
        <div className="Content-bottom-margin">
            <PageTitle title="Posts" brief={
                (selectedCategory ? selectedCategory.value : "All") + " • " + selectedLanguage.value
            }>
                <Link to="./new">
                    <PrimaryButton title="New post" icon={<FiPlus/>}/>
                </Link>
            </PageTitle>
            <FilterHeader>
                <Container fluid>
                    <Row gutterWidth={20} >
                        <Col sm={12} md={7}>
                            { <SelectInput name="posts-categories"
                                           options={postsCategories}
                                           preSelectedOption={selectedCategory}
                                           onChange={postCategorySelectChangeHandler}/>
                            }
                        </Col>
                        <Col sm={12} md={3}>
                            <SelectInput name="post-language-code"
                                         options={Languages}
                                         preSelectedOption={selectedLanguage}
                                         onChange={languageSelectChangeHandler}/>
                        </Col>
                    </Row>
                </Container>
            </FilterHeader>
            <PostsTable items={posts} loading={loading} footer={
                <PaginationTableFooter loading={loading}
                                       currentPage={currentPage}
                                       numberOfPages={ numberOfPages }
                                       onPrevious={ () => { setSkip(skip - limit) } }
                                       onNext={ () => { setSkip(skip + limit) } } >
                </PaginationTableFooter>
            } />
        </div>
    );
};

export default Posts;